<script setup lang="ts">
import { useI18n } from '#imports'

const { t } = useI18n()

// vue-i18n 메시지 컴파일러가 "@"를 linked-message 문법으로 해석해 빌드가 깨지므로
// 이메일 주소는 번역 대상 없는 고정값으로 별도 관리한다.
const contactEmail = 'drcho77@naver.com'

const bottomButtonList = ref([
  { title: t('footerContent.about'), value: 'about' },
  { title: t('footerContent.terms'), value: 'terms' },
  { title: t('footerContent.privacy'), value: 'privacy' },
  { title: t('footerContent.contact'), value: 'contact' },
])

function getButtonLink(value: string) {
  switch (value) {
    case 'privacy':
      return '/legal/privacy'
    case 'terms':
      return '/legal/terms'
    case 'about':
      return '/introduce'
    case 'contact':
      return '/inquiry'
    default:
      return '#'
  }
}
</script>

<template>
  <v-footer class="bg-ing-dark text-white py-8">
    <v-container class="d-flex flex-column mb-10 px-0" fluid :max-width="1280">
      <v-row align="center" no-gutters class="mb-4">
        <v-col cols="12" sm="auto">
          <v-img :max-width="86" src="/ing_2.svg" alt="ing Logo" />
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="auto">
          <v-container class="d-flex align-center justify-sm-end footer-links ma-0 px-0 py-2 flex-row justify-start" fluid>
            <v-container
              v-for="(bottomBtn, bIdx) in bottomButtonList"
              :key="bottomBtn.value" class="ma-0 pa-0" width="fit-content"
            >
              <v-btn
                :to="getButtonLink(bottomBtn.value)" variant="text"
                class="text-body-2 font-pretendard font-weight-regular px-0"
              >
                {{ bottomBtn.title }}
              </v-btn>
              <span v-if="bIdx !== bottomButtonList.length - 1" class="px-2">|</span>
            </v-container>
          </v-container>
        </v-col>
      </v-row>

      <div class="text-body-2 footer-company-info font-weight-light text-c9 opacity-100">
        <span>{{ t('footerContent.starking') }}</span>
        <span class="px-2">|</span>
        <span>{{ t('footerContent.ceo') }} {{ t('footerContent.ceoName') }}</span>
        <br class="d-sm-none">
        <span class="d-none d-sm-inline px-2">|</span>
        <span>{{ t('footerContent.businessNumber') }} {{ t('footerContent.businessNumberDetail') }}</span>
        <br class="d-sm-none">
        <span class="d-none d-sm-inline px-2">|</span>
        <span>{{ t('footerContent.address') }} {{ t('footerContent.addressDetail') }}</span>
        <br class="d-sm-none">
        <span class="d-none d-sm-inline px-2">|</span>
        <span>{{ t('footerContent.tel') }} {{ t('footerContent.telDetail') }}</span>
        <br class="d-sm-none">
        <span class="d-none d-sm-inline px-2">|</span>
        <span>{{ t('footerContent.email') }} <span translate="no">{{ contactEmail }}</span></span>
      </div>

      <v-label class="text-body-2 font-weight-light text-c9 mt-2 opacity-100">
        Copyright © 2025 ing. All rights reserved.
      </v-label>
    </v-container>
  </v-footer>
</template>

<style scoped>
/* 다크 배경 토큰 (DESIGN_SYSTEM.md 2장 — home.vue와 동일하게 #111로 통일) */
.bg-ing-dark {
  background-color: #111 !important;
}

.footer-links a {
  color: #ffffff !important;
  text-decoration: none !important;
}

.footer-links a:hover {
  color: #ffcc00 !important;
  text-decoration: none !important;
  cursor: pointer;
}

.footer-company-info {
  line-height: 1.8;
}
</style>
